let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hEx03")).then(() => parcelRequire('3nJod'));